<div [ngClass]="{
    'right-copy-switch-button':side === LensSide.RIGHT,
    'left-copy-switch-button':side === LensSide.LEFT}">
<app-lens-side-circle [side]="side" [ngClass]="{'circle':side === LensSide.RIGHT}"></app-lens-side-circle>
<!--<app-copy-switch-button [side]="side" (switchEmit)="switch($event)"></app-copy-switch-button>-->
</div>

<form class="d-flex flex-wrap form" [formGroup]="form">
  <h3 class="input-parameter">{{"home.orders.commission" | translate}}
    <input [attr.disabled]="true" formControlName="commission" class="form-control data" [placeholder]="'home.orders.commission' | translate"/>
  </h3>

  <h3 class="input-parameter">{{"return.lot" | translate}}
    <input [attr.disabled]="true" formControlName="chargeNumber" class="form-control data" [placeholder]="'return.lot' | translate"/>
  </h3>

  <h3>
    <div class="data-panel">
      <div *ngIf="!storedDescription">{{"return.clData" | translate}}</div>
      <div *ngIf="storedDescription">{{"return.clDataOriginal" | translate}}</div>
      <div *ngIf="storedDescription" class="right-align">{{"return.clDataUpdated" | translate}}</div>
    </div>
    <div class="data-panel">
      <textarea [attr.disabled]="true" rows="4" cols="30" formControlName="description" class="form-control" [placeholder]="'return.clData' | translate"></textarea>
      <textarea *ngIf="storedDescription" disabled rows="4" cols="30" formControlName="newDescription" class="form-control" [placeholder]="'return.clData' | translate"></textarea>
    </div>
  </h3>

  <div formGroupName="mainRadioGroup" style="width: 100%;">
    <mat-radio-group (change)="cancelChanges()" style="margin-top: 50px;" aria-label="Select an option" formControlName="mainRadioGroupOption">
      <div class="d-flex flex-wrap form" *ngIf="breakagePossible">
        <div style="width: 100%;" class="d-flex flex-wrap">
          <mat-radio-button value="breakage" style="display: block;">{{"return.breakage.label" | translate}}</mat-radio-button>
          <div class="info">
            <img src="assets/img/icons/info.svg" [matTooltip]="'return.breakage.info' | translate" matTooltipPosition="above"/>
          </div>
        </div>
        <div style="margin-left: 5%" *ngIf="form.get('mainRadioGroup').value.mainRadioGroupOption === 'breakage'">
          <div formGroupName="breakageGroup">
            <mat-radio-group formControlName="breakageRadioGroupOption">
              <mat-label><b>{{"return.common.additionLabel" | translate}}</b></mat-label>
              <mat-radio-button value="breakageNewDelivery" style="display: block;">{{"return.common.newDelivery" | translate}}</mat-radio-button>
              <mat-radio-button value="breakageCreditNoteOnly" style="display: block;">{{"return.common.creditNoteOnly" | translate}}</mat-radio-button>
            </mat-radio-group>
            <label *ngIf="form.get('mainRadioGroup').get('breakageGroup').value.breakageRadioGroupOption === 'breakageCreditNoteOnly'" class="input-parameter">{{"return.common.deliveryNumber" | translate}}
              <input formControlName="breakageDeliveryNumber" class="form-control" [placeholder]="'return.common.deliveryNumber' | translate"/>
            </label>
            <label class="send-back-notification">*{{"return.noSendBack" | translate}}</label>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap form" *ngIf="creditNotePossible">
        <mat-radio-button value="returnCreditNote" style="display: block;">{{"return.returnCreditNote.label" | translate}}</mat-radio-button>
        <div class="info">
          <img src="assets/img/icons/info.svg" [matTooltip]="'return.returnCreditNote.info' | translate"/>
        </div>
      </div>
      <div class="d-flex flex-wrap form" style="margin-left: 5%" *ngIf="form.get('mainRadioGroup').value.mainRadioGroupOption === 'returnCreditNote'">
        <label class="send-back-notification">*{{"return.noSendBack" | translate}}</label>
      </div>
      <div class="d-flex flex-wrap form">
        <mat-radio-button value="wrongDelivery" style="display: block;">{{"return.wrongDelivery.label" | translate}}</mat-radio-button>
        <div class="info">
          <img src="assets/img/icons/info.svg" [matTooltip]="'return.wrongDelivery.info' | translate"/>
        </div>
        <div style="margin-left: 5%;" *ngIf="form.get('mainRadioGroup').value.mainRadioGroupOption === 'wrongDelivery'">
          <div formGroupName="wrongDeliveryGroup">
            <label class="input-parameter">{{"return.wrongDelivery.reason" | translate}}
              <input formControlName="wrongDeliveryReason" class="form-control" [placeholder]="'return.wrongDelivery.reason' | translate"/>
            </label>
            <mat-radio-group formControlName="wrongDeliveryRadioGroupOption">
              <mat-label><b>{{"return.common.additionLabel" | translate}}</b></mat-label>
              <mat-radio-button value="wrongDeliveryNewDelivery" style="display: block;">{{"return.common.newDelivery" | translate}}</mat-radio-button>
              <div *ngIf="form.get('mainRadioGroup').get('wrongDeliveryGroup').value.wrongDeliveryRadioGroupOption === 'wrongDeliveryNewDelivery'">
                <button mat-flat-button color="primary" class="action-button" (click)="openCorrectionDialog()">{{"return.wrongDelivery.corrections" | translate}}</button>
              </div>
              <mat-radio-button value="wrongDeliveryCreditNoteOnly" style="display: block;">{{"return.common.creditNoteOnly" | translate}}</mat-radio-button>
            </mat-radio-group>
            <label *ngIf="form.get('mainRadioGroup').get('wrongDeliveryGroup').value.wrongDeliveryRadioGroupOption === 'wrongDeliveryCreditNoteOnly'" class="input-parameter">{{"return.common.deliveryNumber" | translate}}
              <input formControlName="wrongDeliveryNumber" class="form-control" [placeholder]="'return.common.deliveryNumber' | translate"/>
            </label>
            <label class="send-back-notification">*{{"return.needSendBack" | translate}}</label>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap form">
        <div class="d-flex" style="width: 100%">
          <mat-radio-button value="rework" style="display: block;">{{"return.rework.label" | translate}}</mat-radio-button>
        </div>
        <div style="margin-left: 5%;" *ngIf="form.get('mainRadioGroup').value.mainRadioGroupOption === 'rework'">
          <div formGroupName="reworkGroup" class="rework-checkboxes">
            <div class="d-flex" style="width:380px">
              <mat-checkbox formControlName="reworkIntensive">{{"return.rework.intensive" | translate}}</mat-checkbox>
            </div>
            <div class="d-flex" style="width:380px">
              <mat-checkbox formControlName="reworkSurface">{{"return.rework.surface" | translate}}</mat-checkbox>
            </div>
            <div class="d-flex" style="width:380px">
              <mat-checkbox formControlName="reworkDptChange">{{"return.rework.dptChange.label" | translate}}</mat-checkbox>
              <input formControlName="reworkDptChangeInput" class="form-control"/>
              <div class="info">
                <img src="assets/img/icons/info.svg" [matTooltip]="'return.rework.dptChange.info' | translate" matTooltipPosition="above"/>
              </div>
            </div>
            <div class="d-flex" style="width:350px">
              <mat-checkbox formControlName="reworkDiameterReduction">{{"return.rework.diameterReduction" | translate}}</mat-checkbox>
              <input formControlName="reworkDiameterReductionInput" class="form-control"/>
            </div>
            <div class="d-flex" style="width:380px">
              <mat-checkbox formControlName="reworkRemoveEdgeDefect">{{"return.rework.removeEdgeDefect" | translate}}</mat-checkbox>
            </div>
            <div class="d-flex" style="width:380px">
              <mat-checkbox formControlName="reworkChangeEdgeLift">{{"return.rework.changeEdgeLift.label" | translate}}</mat-checkbox>
              <input formControlName="reworkChangeEdgeLiftInput" class="form-control"/>
              <div class="info">
                <img src="assets/img/icons/info.svg" [matTooltip]="'return.rework.changeEdgeLift.info' | translate" matTooltipPosition="above"/>
              </div>
            </div>
          </div>
          <label class="send-back-notification">*{{"return.needSendBack" | translate}}</label>
        </div>
      </div>
      <div class="d-flex flex-wrap form">
        <mat-radio-button value="inspectionCompliant" style="display: block;">{{"return.inspectionCompliant.label" | translate}}</mat-radio-button>
        <div class="info">
          <img src="assets/img/icons/info.svg" [matTooltip]="'return.inspectionCompliant.info' | translate"/>
        </div>
        <div style="margin-left: 5%;" *ngIf="form.get('mainRadioGroup').value.mainRadioGroupOption === 'inspectionCompliant'">
          <div formGroupName="inspectionCompliantGroup" class="inspection-checkboxes">
            <div class="d-flex callback-cb"><mat-checkbox formControlName="inspectionCompliantFirst">{{"return.inspectionCompliant.first" | translate}}</mat-checkbox></div>
            <div class="d-flex callback-cb"><mat-checkbox formControlName="inspectionCompliantSecond">{{"return.inspectionCompliant.second" | translate}}</mat-checkbox></div>
            <div class="d-flex callback-cb"><mat-checkbox formControlName="inspectionCompliantThird">{{"return.inspectionCompliant.third" | translate}}</mat-checkbox></div>
            <div class="d-flex callback-cb"><mat-checkbox formControlName="inspectionCompliantFourth">{{"return.inspectionCompliant.fourth" | translate}}</mat-checkbox></div>
            <div class="d-flex callback-cb"><mat-checkbox formControlName="inspectionCompliantFifth">{{"return.inspectionCompliant.fifth" | translate}}</mat-checkbox></div>
            <!--<mat-checkbox formControlName="inspectionCompliantOther">{{"return.common.other" | translate}}</mat-checkbox>-->
            <label class="input-parameter">{{"return.common.other" | translate}}
              <input formControlName="inspectionCompliantOther" class="form-control">
            </label>
            <br>
            <mat-label><b>{{"return.common.additionLabel" | translate}}</b></mat-label>
            <mat-radio-group formControlName="inspectionCompliantRadioGroupOption">
              <mat-radio-button value="inspectionCompliantNewDelivery" style="display: block;">{{"return.common.newDelivery" | translate}}</mat-radio-button>
              <mat-radio-button value="inspectionCompliantCreditNoteOnly" style="display: block;">{{"return.common.creditNoteOnly" | translate}}</mat-radio-button>
            </mat-radio-group>
            <label class="input-parameter">{{"return.common.deliveryNumber" | translate}}
              <input formControlName="inspectionCompliantDeliveryNumber" class="form-control" [placeholder]="'return.common.deliveryNumber' | translate"/>
            </label>
          </div>
          <label class="send-back-notification">*{{"return.needSendBack" | translate}}</label>
        </div>
      </div>
    </mat-radio-group>
  </div>
  <div class="callback-block">
    <mat-checkbox formControlName="callBack">
      <div style="margin-left: 4px">{{"return.callBack.label" | translate}}</div>
    </mat-checkbox>
    <div class="callBack" *ngIf="form.get('callBack').value">
      <div style="margin-left: 5%;" formGroupName="callBackGroup">
        <label class="input-parameter">{{"return.callBack.mrsMr" | translate}}
          <input formControlName="callBackMrsMr" class="form-control" [placeholder]="'return.callBack.mrsMr' | translate"/>
        </label>
        <label class="input-parameter">{{"return.callBack.phone" | translate}}
          <input formControlName="callBackPhone" class="form-control" [placeholder]="'return.callBack.phone' | translate"/>
        </label>
        <div class="d-flex">
          <label>{{"return.timeRange" | translate}}</label>
        </div>
        <div class="d-flex" style="margin-top: -8px;">
          <div formGroupName="range" style="display: flex">
            <input formControlName="start" type="time" class="form-control time-input" style="margin-right: 10px">
            <label class="range-symbol">-</label>
            <input formControlName="end" type="time" class="form-control time-input" style="margin-left: 10px; margin-right: 7px;">
          </div>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <input formControlName="callBackDate" matInput [matDatepicker]="picker" class="no-pointer-event">
        </div>
        <label class="input-parameter">{{"return.common.other" | translate}}
          <input formControlName="callBackOther" class="form-control" [placeholder]="'return.common.other' | translate"/>
        </label>
      </div>
    </div>
  </div>
</form>
